// extracted by mini-css-extract-plugin
export default {"tab-item-wrapper":"TabItem_tab-item-wrapper__lVu4l","checked":"TabItem_checked__m12By"};